export default "__VITE_ASSET__CdtstTIg__";